/** @jsxRuntime classic */

// This is a place for starter events to extend.
export default function TopMenuItems({ ...rest }) {
  return null;
}
